import React from "react";
import { useSelector } from 'react-redux';
import RewardPointsAndBonus from './../../presentation/rewardPointsAndBonus/RewardPointsAndBonus'
import useMyRewardsPoint from "../../hooks/useMyRewardsPoint";
import useMyBadgeAssignments from "../../hooks/useMyBadgeAssignments";
import { getActivityDisplayMode } from '../../utils/RecognitionModeUtils.js';

const RewardPointsAndBonusContainer = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { rewardPointsBonus } = useMyRewardsPoint();
  const { badgeList } = useMyBadgeAssignments(currentUser, false, () => {});
  
  const displayMode = getActivityDisplayMode(currentUser?.company);
  const isRecognitionMode = displayMode === 'recent_activity';
  
  let recognitionTotals = null;
  if (isRecognitionMode && badgeList) {
    const recognitions = badgeList.filter(badge => badge.badgeType?.includes('PEERTOPEER') || badge.badgeType?.includes('On-the-Spot'));
    const nominations = badgeList.filter(badge => badge.badgeType?.includes('NOMINATED'));
    const gifts = badgeList.filter(badge => badge.snappyGrantId);
    
    recognitionTotals = {
      recognitions: recognitions.length,
      nominations: nominations.length,
      gifts: gifts.length
    };
  }
  
  return (
    <RewardPointsAndBonus
      rewardPointsBonus={rewardPointsBonus}
      isRecognitionMode={isRecognitionMode}
      recognitionTotals={recognitionTotals}
    />
  );
};

export default RewardPointsAndBonusContainer;
